import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  buttonStyles,
} from '@lognai/synapse-design-system-v2';

/**
 * The confirmation destructive actions in the shell go through.
 *
 * Some of them used the browser's own `window.confirm` instead — unstyled,
 * unthemed, and unmistakably not part of the product (QA ledger SHIP-006).
 */
export interface ConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmVariant?: 'primary' | 'destructive';
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  title,
  description,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  confirmVariant = 'destructive',
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>{cancelButtonText}</AlertDialogCancel>
        {/* AlertDialogAction is destructive by default; cn is last-wins, so a
            caller-supplied variant overrides it. */}
        <AlertDialogAction onClick={onConfirm} className={buttonStyles({ variant: confirmVariant })}>
          {confirmButtonText}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
